import { takeLeading, put, call } from 'redux-saga/effects';

import { Creators, Types } from 'src/store/redux/roles/actions';
import rolesApi from 'src/services/api/roles';
import toaster from 'src/services/toaster';
import { DBErrorMonitor } from 'src/services/error-monitor';

export function* get(action: any) {
  try {
    const response = yield call(rolesApi.get, action.roleId);
    yield put(Creators.rolesGetRequestSuccess(response.data));
  } catch (e) {
    DBErrorMonitor.captureException(e, { saga: 'get', entity: 'roles' });
    toaster.error(e.message);
    let error = e.response;
    yield put(Creators.rolesGetRequestError(error));
  }
}

export function* watchGet() {
  yield takeLeading(Types.ROLES_GET_REQUEST, get);
}

export default watchGet;
